import { Link } from "react-router-dom";
import { UserLayout } from "./components/layout/UserLayout";
import Container from "./components/Container";
import Text from "./components/Text";
import PageHero from "./components/PageHero";
import Img from "./components/Img";
import { ROUTE_PATHS } from "../../constants/routeConstants";

const STATS = [
  { value: "20+", label: "Years of Experience" },
  { value: "500+", label: "Products" },
  { value: "10+", label: "Industries Served" },
  { value: "100+", label: "Trusted Clients" },
];

const HIGHLIGHTS = [
  { label: "Genuine & Quality Products" },
  { label: "Trusted Procurement Partner" },
  { label: "Competitive Pricing" },
  { label: "Nationwide Supply Network" },
  { label: "Professional Customer Support" },
  { label: "Fast & Reliable Deliveries" },
  { label: "Technical Product Assistance" },
];

const About = () => {
  return (
    <UserLayout>
      <PageHero title="About Us" crumbs={[{ label: "About Us" }]} />

      <Container variant="xnarrow" className="px-6 py-14 space-y-16">
        {/* Our Story */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <Text is="h2" className="text-2xl font-bold text-gray-900 mb-4">
              Who We Are
            </Text>
            <Text is="p" className="text-sm text-gray-600 leading-relaxed mb-4">
              Ukasha Enterprises provides industrial, laboratory and MRO solutions throughout Pakistan.
              We are committed to providing genuine products, competitive pricing and reliable procurement
              services to industrial, commercial and government sectors.
            </Text>
            <Text is="p" className="text-sm text-gray-600 leading-relaxed">
              Our objective is to build long-term partnerships by delivering quality products and
              professional support that meet the evolving needs of our customers.
            </Text>
          </div>
          <div className="rounded-lg aspect-[4/3] w-full overflow-hidden">
            <Img src="/Coprate Office.jpg.jpeg" alt="Ukasha Enterprises Office" className="w-full h-full object-cover" />
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="border border-gray-100 rounded-lg p-6 text-center"
            >
              <Text is="p" className="text-2xl font-bold text-gray-900 mb-1">
                {stat.value}
              </Text>
              <Text is="p" className="text-xs text-gray-500">
                {stat.label}
              </Text>
            </div>
          ))}
        </div>

        {/* Mission */}
        <div className="bg-gray-50 rounded-lg p-10 text-center">
          <Text is="h2" className="text-2xl font-bold text-gray-900 mb-4">
            Our Mission
          </Text>
          <Text
            is="p"
            className="text-sm text-gray-600 leading-relaxed max-w-2xl mx-auto"
          >
            To provide industrial, laboratory and aviation sectors across Pakistan with genuine,
            high-performance products and reliable procurement solutions — delivered with
            professionalism, competitive pricing and a commitment to long-term partnership.
          </Text>
        </div>

        {/* Why Choose Us */}
        <div>
          <Text is="h2" className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Why Choose Ukasha Enterprises?
          </Text>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {HIGHLIGHTS.map((item) => (
              <div
                key={item.label}
                className="flex items-center gap-3 border border-gray-100 rounded-lg px-5 py-3"
              >
                <span className="w-2 h-2 rounded-full bg-blue-500 flex-shrink-0" />
                <Text is="p" className="text-sm text-gray-700 font-medium">
                  {item.label}
                </Text>
              </div>
            ))}
          </div>
        </div>

        {/* Business Profile CTA */}
        <div className="border border-gray-100 rounded-lg p-10 text-center">
          <Text is="h2" className="text-xl font-bold text-gray-900 mb-3">
            Learn More About Us
          </Text>
          <Text is="p" className="text-sm text-gray-500 mb-6 max-w-lg mx-auto">
            View our full business profile — product ranges, industries we serve, trusted brands and more.
          </Text>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to={ROUTE_PATHS.BUSINESS_PROFILE}
              className="inline-block bg-gray-900 hover:bg-gray-700 transition-colors text-white text-sm font-semibold px-8 py-3 rounded"
            >
              View Business Profile
            </Link>
            <Link
              to={ROUTE_PATHS.CONTACT}
              className="inline-block border border-gray-300 hover:border-gray-900 transition-colors text-gray-700 text-sm font-semibold px-8 py-3 rounded"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </Container>
    </UserLayout>
  );
};

export default About;
